document.addEventListener('DOMContentLoaded', function () {
  const STORAGE_KEY = 'ta-view-mode';
  let currentMode = localStorage.getItem(STORAGE_KEY) || 'worn';

  function swapDesktopImages(wrapper, mode) {
    const isFlatlay = mode === 'flatlay';

    const mainSrc = isFlatlay
      ? (wrapper.dataset.flatlaySrc || wrapper.dataset.wornSrc)
      : wrapper.dataset.wornSrc;

    const altSrc = isFlatlay
      ? (wrapper.dataset.flatlayAltSrc || wrapper.dataset.flatlaySrc || wrapper.dataset.wornAltSrc)
      : wrapper.dataset.wornAltSrc;

    const mainImg = wrapper.querySelector('.ProductCard__Image:not(.ProductCard__Image--alternate)');
    if (mainImg && mainSrc) {
      mainImg.removeAttribute('loading');
      mainImg.srcset = '';
      mainImg.src = mainSrc;
    }

    const altImg = wrapper.querySelector('.ProductCard__Image--alternate');
    if (altImg && altSrc) {
      altImg.removeAttribute('loading');
      altImg.srcset = '';
      altImg.src = altSrc;
      new Image().src = altSrc;
    }
  }

  function swapMobileGallery(mode) {
    document.querySelectorAll('.ta-mobile-slide[data-worn-src]').forEach(function (slide) {
      const src = mode === 'flatlay'
        ? (slide.dataset.flatlaySrc || slide.dataset.wornSrc)
        : slide.dataset.wornSrc;
      const img = slide.querySelector('img');
      if (img && src) {
        img.srcset = '';
        img.src = src;
      }
    });
  }

  function applyView(mode) {
    currentMode = mode;

    // Mobile: swap src in the 2 gallery slides
    swapMobileGallery(mode);

    // Desktop: swap src on image wrappers
    document.querySelectorAll('.ProductCard__ImageWrapper[data-worn-src]').forEach(function (wrapper) {
      swapDesktopImages(wrapper, mode);
    });

    // Toggle button active state
    document.querySelectorAll('.ViewToggle__Btn').forEach(function (btn) {
      btn.classList.toggle('ViewToggle__Btn--active', btn.dataset.view === mode);
    });

    localStorage.setItem(STORAGE_KEY, mode);
  }

  // Infinite scroll: apply swaps to newly added products
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        node.querySelectorAll('.ProductCard__ImageWrapper[data-worn-src]').forEach(function (wrapper) {
          swapDesktopImages(wrapper, currentMode);
        });
        if (currentMode !== 'worn') {
          node.querySelectorAll('.ta-mobile-slide[data-worn-src]').forEach(function (slide) {
            const src = currentMode === 'flatlay'
              ? (slide.dataset.flatlaySrc || slide.dataset.wornSrc)
              : slide.dataset.wornSrc;
            const img = slide.querySelector('img');
            if (img && src) { img.srcset = ''; img.src = src; }
          });
        }
      });
    });
  });

  const grid = document.querySelector('.Grid');
  if (grid) {
    observer.observe(grid, { childList: true, subtree: true });
  }

  document.querySelectorAll('.ViewToggle__Btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      applyView(btn.dataset.view);
    });
  });

  applyView(currentMode);
});
